import React, { useState } from 'react'

import { useUSSchoolsMutation } from '@mote/api'

const US_STATES = [
  'AL',
  'AK',
  'AS',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FM',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MH',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PW',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VI',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
]

export const LabsSchoolSearchScreen = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [stateOverride, setStateOverride] = useState('')
  const [disableGeoIp, setDisableGeoIp] = useState(false)

  const {
    data,
    loading: networkBusy,
    error: networkError,
    mutate
  } = useUSSchoolsMutation()

  const searchResults = data?.search?.matches || []

  function issueQuery(text) {
    if (!text.length) {
      return
    }
    mutate({
      variables: {
        searchTerm: text,
        stateOverride: stateOverride,
        disableGeoIp: disableGeoIp
      }
    })
  }

  return (
    <div>
      <p>
        <b>Proto search client</b>
      </p>

      <p>Enter a school name or zip code:</p>

      <form>
        <input
          autoFocus
          type='text'
          border='1'
          value={searchTerm}
          onChange={e => {
            const text = e.target.value
            setSearchTerm(text)
            issueQuery(text)
          }}
        />
      </form>

      <br />

      <p>
        <b>Labs mode only:</b> Pick alternative US state: &nbsp;
        <select
          border={1}
          value={stateOverride}
          onChange={e => {
            setStateOverride(e.target.value)
            issueQuery(searchTerm)
          }}
        >
          <option value='' />
          {US_STATES.map(state => {
            return <option key={state}>{state}</option>
          })}
        </select>
      </p>

      <p>
        <b>Labs mode only:</b> Disable automatic state GeoIP? &nbsp;
        <input
          name='disableGeoIp'
          type='checkbox'
          checked={disableGeoIp}
          onChange={() => {
            setDisableGeoIp(!disableGeoIp)
            issueQuery(searchTerm)
          }}
        />
      </p>

      <p>
        <b>Labs mode only: Is network busy?</b> {networkBusy ? 'yes' : 'no'} (we
        will show some spinner instead in final, polished version)
      </p>

      {networkError && (
        <div>
          <p>
            <font color='red'>Something bad happened</font>
          </p>
        </div>
      )}

      {data && (
        <div>
          <p>Total hits: {searchResults.length}</p>

          {searchResults && (
            <ul>
              {searchResults.map(result => {
                return (
                  <li key={result.forSubmission.schoolId}>
                    {result.forDisplay.schoolName.toUpperCase()}
                  </li>
                )
              })}
            </ul>
          )}
        </div>
      )}

      <br />
      <br />
      <br />
      <br />
      <p />

      <p>
        <b>Notes to friendly mote testers:</b>
        <ol>
          <li>
            Does it feel responsive enough as you type? Tell me if you think
            it's bad, it's probably sluggish compared to Google but that's OK
          </li>
          <li>
            If you are in the USA, did it prioritise search results in your
            state and neighbouring states? If you see local schools further down
            the search rankings, our GeoIP is not always finding your state. I
            would love to see a Loom.
          </li>
          <li>
            What is your experience of using on a mobile phone with respect to
            defaulting to a sensible state. I Do you find you have If you are in
            the USA, did it prioritise search results in your state and
            neighbouring states? If you see local schools further down the
            search rankings, our GeoIP is not always finding your state. I am
            curious if GeoIP on US cellular networks is accurate to the state
            level.
          </li>
        </ol>
      </p>
    </div>
  )
}
